import { render, staticRenderFns } from "./Gateway.vue?vue&type=template&id=3c3cebc8&scoped=true&"
import script from "./Gateway.vue?vue&type=script&lang=js&"
export * from "./Gateway.vue?vue&type=script&lang=js&"
import style0 from "./Gateway.vue?vue&type=style&index=0&id=3c3cebc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3cebc8",
  null
  
)

export default component.exports